<template lang='pug'>
  .app
    AppHeader
    .app-body
      Sidebar(:navItems='nav')
      main.main
        breadcrumb(:list='list')
        .container-fluid
          router-view
    AppFooter
</template>

<script>
import { sidebarItems } from '../_nav'
import { Header as AppHeader, Sidebar, Footer as AppFooter, Breadcrumb } from '../components/'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: sidebarItems().items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue